/* eslint-disable react/no-array-index-key */
/* eslint-disable sort-keys */
import React from 'react'

import { CarouselComponent } from '../../components'
import PromotedTreatment from '../../components/PromotedTreatment/PromotedTratment'
import HeadingComponent from '../../components/Typography/HeadingComponent/HeadingComponent'
import { promotedTitles, promotedTreatments } from '../../constants/constData'
import useMediaQuery from '../../hooks/useMediaQuery'
import { useTreatmenttsData } from '../../hooks/useTreatmentsData'
import { sectionContainer } from '../../styles/shared.module.css'
import {
  carouselContainer,
  headingAligment,
} from './PromotedTreatments.module.css'

const PromotedTreatments = ({ lang, slice }) => {
  const { treatments } = slice
  const localizedPromoTreatments = promotedTreatments[lang]
  const defaultData = useTreatmenttsData()
  const isDesktop = useMediaQuery('(min-width: 1600px)')
  const isMedium = useMediaQuery('(min-width: 1224px)')
  const isSmall = useMediaQuery('(min-width: 768px)')
  const useSlicetData = treatments?.nodes?.length > 3
  const treatmentsList = useSlicetData
    ? treatments?.nodes
    : defaultData
        .filter(
          (item) =>
            item.language.slug === lang &&
            localizedPromoTreatments.includes(`/${item.pageType.uri}/`),
        )
        .sort((a, b) => {
          return (
            localizedPromoTreatments.indexOf(`/${a.pageType.uri}/`) -
            localizedPromoTreatments.indexOf(`/${b.pageType.uri}/`)
          )
        })
  const localizedTitles = promotedTitles[lang]
  const randomTitle = localizedTitles[0]

  const getSlidesPerView = () => {
    if (isDesktop) return 4
    if (isMedium) return 3
    if (isSmall) return 2
    return 1
  }
  return (
    <section className={`${sectionContainer} ${carouselContainer}`}>
      <HeadingComponent extraClassName={headingAligment}>
        {randomTitle}
      </HeadingComponent>
      <CarouselComponent slidesPerView={getSlidesPerView()} withoutNav={false}>
        {treatmentsList.map((treatment, index) => (
          <PromotedTreatment
            key={index}
            defaultData={!useSlicetData}
            treatment={treatment}
          />
        ))}
      </CarouselComponent>
    </section>
  )
}

export default PromotedTreatments
